import {
    ROOM_CREATED,
    ROOM_STATE,
    ROOM_ERROR,
    ROOM_LEAVE,
    ROOM_JOIN,
    ROOM_START_GAME,
    ROOM_RECONNECT,
    ADD_PLAYER,
    REMOVE_PLAYER,
    UPDATE_PLAYER,
    ADD_AVATAR,
    UPDATE_AVATAR,
} from "actions/types";
import * as Colyseus from "colyseus.js";
import { findPlayableGameById } from "constants/GameListAdapter";
import Store from "store/reduxstore";
import { UAParser } from "ua-parser-js";
import * as Sentry from "@sentry/react";
import { APP_TYPES } from "../constants/AppTypes";
//import { datadogRum } from '@datadog/browser-rum';

console.log(process.env.REACT_APP_GAME_SERVER_URL);
const client = new Colyseus.Client(process.env.REACT_APP_GAME_SERVER_URL);

// Debounce for redirect_to_external_game messages to prevent duplicates
let lastExternalRedirectTimestamp = 0;
const EXTERNAL_REDIRECT_DEBOUNCE_MS = 5000;

// Check if running on localhost
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Helper to get game URL from environment variable
// e.g., gameId "catchphrase" -> REACT_APP_CATCHPHRASE_URL
const getEnvGameUrl = (gameId) => {
    const envKey = `REACT_APP_${gameId.toUpperCase()}_URL`;
    return process.env[envKey];
};

// Helper to normalize URL (trim whitespace and ensure it has a protocol)
const normalizeUrl = (url) => {
    if (!url) return url;
    // Trim whitespace from start and end
    url = url.trim();
    // If URL doesn't start with http:// or https://, add https://
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`;
    }
    return url;
};

// Helper to get game URL
// - On localhost: use env vars for local development
// - Not on localhost: use CMS database first, fall back to env vars
const getGameUrl = (gameId) => {
    // On localhost, use env vars for local development
    if (isLocalhost) {
        const envUrl = getEnvGameUrl(gameId);
        if (envUrl) {
            return normalizeUrl(envUrl);
        }
    }

    // Not on localhost (or no env var): try CMS database first
    const game = findPlayableGameById(gameId);
    if (game?.gameUrl) {
        return normalizeUrl(game.gameUrl);
    }

    // Fall back to environment variable if CMS has no URL
    const envUrl = getEnvGameUrl(gameId);
    if (envUrl) {
        console.log(`[room] No CMS URL for ${gameId}, using env fallback: ${envUrl}`);
        return normalizeUrl(envUrl);
    }

    return null;
};


export const createRoom = (token, userId, platform = APP_TYPES.WEB, isRoku = false, QRSessionID = null, roomCode = null, externalGameToken = null) => (dispatch) => {
    const reduxStore = Store.getState();

    const uniqueId = localStorage.getItem("uniqueId");
    var parser = new UAParser();
    const deviceDetails = parser.getResult();
    const countryCode = reduxStore.pricing.countryCode;

    var user = localStorage.getItem("user");
    if (typeof user === "string") {
        user = JSON.parse(user);
    } 

    console.log("Create Room user ", user);
    let password = null;
    console.log("user email : ", user.email);
    console.log("Room pin : ", user.roomPin);
    if (user?.roomPin) {
        console.log("Room pin : ", user.roomPin);
        password = user.roomPin;
    }

    const networkDetails = {
        type: navigator?.connection?.type,
        effectiveType: navigator?.connection?.effectiveType,
        downlink: navigator?.connection?.downlink,
    };
    console.log("Redux action create room session: " + QRSessionID)
    return client.create("game_city_room", { isHost: true,
        accessToken: token,
        userId: userId,
        email: reduxStore.auth.user?.email,
        hostUniqueId: uniqueId,
        deviceDetails,
        networkDetails,
        isRoku,
        QRSessionID,
        platform,
        countryCode,
        password,
        roomCode,
        externalGameToken,
    }).then(room => {
        console.log("room created");
        console.log("Reconnection Token : ", room.reconnectionToken);
        //datadogRum.setUser({
        //    id: room.roomId,
        //    email: reduxStore.auth.user.email,
        //});

        const $ = Colyseus.getStateCallbacks(room);

        room.send("update_host_token", { reconnectionToken: room.reconnectionToken });
        room.onStateChange.once((state) => {
            console.log("this is the first room state!", state);
            //room.send("host_joined_lobby");
            console.log("room : ", room)
            dispatch({ type: ROOM_CREATED, payload: { room, state } });
        });
        room.onStateChange((state) => {
            console.log(room.name, "has new state:", state);

            dispatch({ type: ROOM_STATE, payload: { roomState: state, } });
        });


        $(room.state).avatarList.onAdd((avatar, key) => {
            //console.log(avatar, "has been added at", key);
            dispatch({ type: ADD_AVATAR, payload: { avatar, } });

            $(avatar).onChange(() => {
                //dispatch({ type: UPDATE_PLAYER, payload: { player, changes, } });
            });
            $(avatar).listen("id", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "id", value, } });
            });
            $(avatar).listen("inUse", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "inUse", value, } });
            });
            $(avatar).listen("isActive", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "isActive", value, } });
            });
        });

        $(room.state).players.onAdd((player, key) => {
            console.log(player, "has been added at", key);
            dispatch({ type: ADD_PLAYER, payload: { player, } });

            $(player).onChange(() => {
                //dispatch({ type: UPDATE_PLAYER, payload: { player, changes, } });
            });
            $(player).listen("avatar", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "avatar", value, } });
            });
            $(player).listen("name", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "name", value, } });
            });
            $(player).listen("gameVote", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "gameVote", value, } });
            });
            $(player).listen("connected", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "connected", value, } });
            });
            $(player).listen("connectingTimer", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "connectingTimer", value, } });
            });
            $(player).listen("primaryPlayer", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "primaryPlayer", value, } });
            });
        });

        $(room.state).players.onRemove((player, key) => {
            console.log(player, "has been removed at", key);
            
            dispatch({ type: REMOVE_PLAYER, payload: { player, } });
        });

        room.onMessage("game_starting", (message) => {
            console.log("game_starting", "received on", room.name, message);
            let gameURL = getGameUrl(message.gameId);
            dispatch({ type: ROOM_START_GAME, payload: { gameURL, gameId: message.gameId, reconnectionToken: room.reconnectionToken } });
        });

        // Handle redirect to external game server (e.g., SongBlast)
        // lobbyUrl and platform are stored in Redis, fetched by external game server
        // hostToken is passed via URL for host authentication
        room.onMessage("redirect_to_external_game", (message) => {
            console.log("redirect_to_external_game", "received on", room.name, message);

            // Debounce to prevent duplicate redirects from reconnection or message replay
            const now = Date.now();
            if (now - lastExternalRedirectTimestamp < EXTERNAL_REDIRECT_DEBOUNCE_MS) {
                console.log("Ignoring duplicate redirect_to_external_game (debounced)");
                return;
            }
            lastExternalRedirectTimestamp = now;

            // Get frontend URL from game data (CMS or env fallback)
            const frontendUrl = getGameUrl(message.gameId);
            const { roomCode, serverUrl, hostToken } = message;

            // Host URL includes token for authentication
            // Client URL is minimal (no sensitive data)
            const hostUrl = `${frontendUrl}?code=${roomCode}&token=${hostToken}`;
            const clientUrl = `${frontendUrl}/client?code=${roomCode}`;

            // This is createRoom (host), so use hostUrl
            dispatch({ type: ROOM_START_GAME, payload: {
                gameURL: hostUrl,
                gameId: message.gameId,
                reconnectionToken: room.reconnectionToken,
                isExternalGame: true,
                roomCode,
                hostUrl,
                clientUrl,
                serverUrl,  // Colyseus server for API calls
            }});
        });

        room.onError((code, message) => {
            console.log(code, " error ", message);

            dispatch({ type: ROOM_ERROR, payload: { error: message, errorMessage: message, errorCode: code } });
        });

        room.onLeave((code) => {
            console.log(client.id, "left", room.name, "code", code);

            dispatch({ type: ROOM_LEAVE, payload: { errorCode:code } });
        });

        return { Status: "Success", room };

    }).catch((err, errorMessage) => {
        console.log("CREATE ERROR", err);
        dispatch({ type: ROOM_ERROR, payload: { error: err, message: err.message } });
        Sentry.captureMessage("Error Creating Room : " + JSON.stringify(err));
        return { Status: "Error", Message: "There was a problem creating your room." };
    });

};


export const joinRoom = (roomId, options) => (dispatch) => {

    const uniqueId = localStorage.getItem("uniqueId");
    options.uniqueId = uniqueId;

    var parser = new UAParser();
    options.deviceDetails = parser.getResult();

    const networkDetails = {
        type: navigator?.connection?.type,
        effectiveType: navigator?.connection?.effectiveType,
        downlink: navigator?.connection?.downlink,
    };
    options.networkDetails = networkDetails;

    return client.joinById(roomId, options).then(room => {
        console.log(room.sessionId, "joined", room.name);
        //this.storeSessionId(room.sessionId);
        //this.storeRoomId(roomId);
        console.log("Reconnection Token : ", room.reconnectionToken);

        const $ = Colyseus.getStateCallbacks(room);

        // Don't send update_player_token on initial join - OnJoinCommand.js already sets the
        // full token (ROOMCODE:sessionId-V3) server-side. Sending this would overwrite with
        // the client's token which may not have the room code prefix yet.
        // room.send("update_player_token", { reconnectionToken: room.reconnectionToken });
        room.onStateChange.once((state) => {
            console.log("this is the first room state!", JSON.stringify(state));

            dispatch({ type: ROOM_JOIN, payload: { room, state } });
            //this.startLocationChecks();
        });

        room.onStateChange((state) => {
            console.log(room.name, "has new state:", state);

            dispatch({ type: ROOM_STATE, payload: { roomState: state, } });
        });

        $(room.state).avatarList.onAdd((avatar, key) => {
            console.log(avatar, "has been added at", key);
            dispatch({ type: ADD_AVATAR, payload: { avatar, } });

            $(avatar).onChange(() => {
                //dispatch({ type: UPDATE_PLAYER, payload: { player, changes, } });
            });
            $(avatar).listen("id", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "id", value, } });
            });
            $(avatar).listen("inUse", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "inUse", value, } });
            });
            $(avatar).listen("isActive", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "isActive", value, } });
            });
        });

        $(room.state).players.onAdd((player, key) => {
            console.log(player, "has been added at", key);
            dispatch({ type: ADD_PLAYER, payload: { player, } });

            $(player).onChange(() => {
                //dispatch({ type: UPDATE_PLAYER, payload: { player, changes, } });
            });
            $(player).listen("avatar", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "avatar", value, } });
            });
            $(player).listen("name", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "name", value, } });
            });
            $(player).listen("gameVote", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "gameVote", value, } });
            });
            $(player).listen("connected", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "connected", value, } });
            });
            $(player).listen("connectingTimer", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "connectingTimer", value, } });
            });
            $(player).listen("primaryPlayer", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "primaryPlayer", value, } });
            });
        });

        $(room.state).players.onRemove((player, key) => {
            console.log(player, "has been removed at", key);

            dispatch({ type: REMOVE_PLAYER, payload: { player, } });
        });

        room.onMessage("game_starting", (message) => {
            console.log("game_starting", "received on", room.name, message);
            let gameURL = getGameUrl(message.gameId);
            dispatch({ type: ROOM_START_GAME, payload: { gameURL, gameId: message.gameId, reconnectionToken: room.reconnectionToken } });
        });

        // Handle redirect to external game server (e.g., SongBlast)
        // lobbyUrl and platform are stored in Redis, fetched by external game server
        // hostToken is passed via URL for host authentication
        room.onMessage("redirect_to_external_game", (message) => {
            console.log("redirect_to_external_game", "received on", room.name, message);

            // Debounce to prevent duplicate redirects from reconnection or message replay
            const now = Date.now();
            if (now - lastExternalRedirectTimestamp < EXTERNAL_REDIRECT_DEBOUNCE_MS) {
                console.log("Ignoring duplicate redirect_to_external_game (debounced)");
                return;
            }
            lastExternalRedirectTimestamp = now;

            // Get frontend URL from game data (CMS or env fallback)
            const frontendUrl = getGameUrl(message.gameId);
            const { roomCode, serverUrl, hostToken } = message;

            // Get current player's name and avatar to pass to external game (for display)
            const myPlayer = room.state.players.get(room.sessionId);
            const playerName = myPlayer?.name || '';
            const playerAvatar = myPlayer?.avatar || '';

            // Host URL includes token for authentication
            // Client URL includes name/avatar for display (no sensitive data)
            const hostUrl = `${frontendUrl}?code=${roomCode}&token=${hostToken}`;
            let clientUrl = `${frontendUrl}/client?code=${roomCode}`;
            if (playerName) {
                clientUrl += `&name=${encodeURIComponent(playerName)}`;
            }
            if (playerAvatar) {
                clientUrl += `&avatar=${encodeURIComponent(playerAvatar)}`;
            }

            // This is joinRoom (player), so use clientUrl
            dispatch({ type: ROOM_START_GAME, payload: {
                gameURL: clientUrl,
                gameId: message.gameId,
                reconnectionToken: room.reconnectionToken,
                isExternalGame: true,
                roomCode,
                hostUrl,
                clientUrl,
                serverUrl,  // Colyseus server for API calls
            }});
        });

        room.onError((code, message) => {
            console.log(code, " error ", message);
            dispatch({ type: ROOM_ERROR, payload: { message, code } });
        });

        room.onLeave((code) => {
            console.log(client.id, "left", room.name);

            dispatch({ type: ROOM_LEAVE, payload: { } });
        });

        return { Status: "Success", room };
    }).catch((err, errorMessage) => {
        console.log("JOIN ERROR", err);

        const message = err.message ? err.message : "An error occured.";
        dispatch({ type: ROOM_ERROR, payload: { error: err, message, } });
        Sentry.captureMessage("Error Joining Room : " + JSON.stringify(err));

        return { Status: "Error", Message: message};
    });

};

export const reconnectToRoom = (token) => (dispatch) => {
    return client.reconnect(token).then(room => {
        console.log(room.sessionId, "joined", room.name);
        //this.storeSessionId(room.sessionId);
        //this.storeRoomId(roomId);
        console.log("Reconnection Token : ", room.reconnectionToken);

        const $ = Colyseus.getStateCallbacks(room);

        room.onStateChange.once((state) => {
            console.log("this is the first room state!", state);

            if (room.state.host.id === room.sessionId) {
                room.send("update_host_token", { reconnectionToken: room.reconnectionToken });
                room.send("host_joined_lobby", {});
            } else {
                room.send("update_player_token", { reconnectionToken: room.reconnectionToken });
            }

            dispatch({ type: ROOM_RECONNECT, payload: { room, state, } });
            //this.startLocationChecks();
        });

        room.onStateChange((state) => {
            console.log(room.name, "has new state:", state);

            dispatch({ type: ROOM_STATE, payload: { roomState: state, } });
        });

        $(room.state).avatarList.onAdd((avatar, key) => {
            //console.log(avatar, "has been added at", key);
            dispatch({ type: ADD_AVATAR, payload: { avatar, } });

            $(avatar).onChange(() => {
                //dispatch({ type: UPDATE_PLAYER, payload: { player, changes, } });
            });
            $(avatar).listen("id", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "id", value, } });
            });
            $(avatar).listen("inUse", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "inUse", value, } });
            });
            $(avatar).listen("isActive", (value) => {
                dispatch({ type: UPDATE_AVATAR, payload: { avatar, field: "isActive", value, } });
            });
        });

        $(room.state).players.onAdd((player, key) => {
            console.log(player, "has been added at", key);
            dispatch({ type: ADD_PLAYER, payload: { player, } });

            $(player).onChange(() => {
                //dispatch({ type: UPDATE_PLAYER, payload: { player, changes, } });
            });
            $(player).listen("avatar", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "avatar", value, } });
            });
            $(player).listen("name", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "name", value, } });
            });
            $(player).listen("gameVote", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "gameVote", value, } });
            });
            $(player).listen("connected", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "connected", value, } });
            }); 
            $(player).listen("connectingTimer", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "connectingTimer", value, } });
            });
            $(player).listen("primaryPlayer", (value) => {
                dispatch({ type: UPDATE_PLAYER, payload: { player, field: "primaryPlayer", value, } });
            });
        });

        $(room.state).players.onRemove((player, key) => {
            console.log(player, "has been removed at", key);

            dispatch({ type: REMOVE_PLAYER, payload: { player, } });
        });

        room.onMessage("game_starting", (message) => {
            console.log("game_starting", "received on", room.name, message);
            let gameURL = getGameUrl(message.gameId);
            dispatch({ type: ROOM_START_GAME, payload: { gameURL, gameId: message.gameId, reconnectionToken: room.reconnectionToken } });
        });

        // Handle redirect to external game server (e.g., SongBlast)
        // lobbyUrl and platform are stored in Redis, fetched by external game server
        // hostToken is passed via URL for host authentication
        room.onMessage("redirect_to_external_game", (message) => {
            console.log("redirect_to_external_game", "received on", room.name, message);

            // Debounce to prevent duplicate redirects from reconnection or message replay
            const now = Date.now();
            if (now - lastExternalRedirectTimestamp < EXTERNAL_REDIRECT_DEBOUNCE_MS) {
                console.log("Ignoring duplicate redirect_to_external_game (debounced)");
                return;
            }
            lastExternalRedirectTimestamp = now;

            // Get frontend URL from game data (CMS or env fallback)
            const frontendUrl = getGameUrl(message.gameId);
            const { roomCode, serverUrl, hostToken } = message;

            // Get current player's name and avatar to pass to external game (for display)
            const myPlayer = room.state.players.get(room.sessionId);
            const playerName = myPlayer?.name || '';
            const playerAvatar = myPlayer?.avatar || '';

            // Host URL includes token for authentication
            // Client URL includes name/avatar for display (no sensitive data)
            const hostUrl = `${frontendUrl}?code=${roomCode}&token=${hostToken}`;
            let clientUrl = `${frontendUrl}/client?code=${roomCode}`;
            if (playerName) {
                clientUrl += `&name=${encodeURIComponent(playerName)}`;
            }
            if (playerAvatar) {
                clientUrl += `&avatar=${encodeURIComponent(playerAvatar)}`;
            }

            // Check if this is the host or a player
            const isHost = room.state.host?.id === room.sessionId;
            dispatch({ type: ROOM_START_GAME, payload: {
                gameURL: isHost ? hostUrl : clientUrl,
                gameId: message.gameId,
                reconnectionToken: room.reconnectionToken,
                isExternalGame: true,
                roomCode,
                hostUrl,
                clientUrl,
                serverUrl,  // Colyseus server for API calls
            }});
        });

        room.onError((code, message) => {
            console.log(code, " error ", message);
            dispatch({ type: ROOM_ERROR, payload: { message, code } });
        });

        room.onLeave((code) => {
            console.log(client.id, "left", room.name);

            dispatch({ type: ROOM_LEAVE, payload: {} });
        });

        return { Status: "Success", room, };
    }).catch((err, errorMessage) => {
        console.log("JOIN ERROR", err);

        const message = err.message ? err.message : "An error occured.";
        dispatch({ type: ROOM_ERROR, payload: { error: err, message} });

        Sentry.captureMessage("Error Reconnecting to Room : " + JSON.stringify(err));
        return { Status: "Error", Message: message, };
    });

};


export const leaveRoom = () => (dispatch) => {
    const reduxStore = Store.getState();
    reduxStore.room.room.leave(true);

    dispatch({ type: ROOM_LEAVE, payload: { } });
};